import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";
import Modal from "../components/Modal";

export default function Project() {
  const { data } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [detailNav, setdetailNav] = useState(false);
  const handleOpen = () => {
      // 模拟数据传入
      setOpen(true);
  };
  function scrollTop (){
    document.getElementById("app").scrollTo({
      top: 0,
      behavior: "smooth" // 平滑滚动
    }); 
  }

 


  return (
    <div className="page page1111" id="pMember">
      <img src={`/image/5.png`} className="pageTitle" />
      <div  className="pContent" >
        <div  className="card clearfix">
          <div  className="cardName flexBox">
            <img  src="image/黑卡.jpg" alt="" />
            黑卡会员 10,000RMB
          </div>
          <div  className="cardInfo flexBox">
            <p >
              <strong >基础权益</strong>
            </p>
            <p >·店内部分项目享受7.5折优惠。</p>
            <p >·产品购买8折优惠</p>
            <p >&nbsp;</p>
            <p >
              <strong >增值权益</strong>
            </p>
            <p >·赠送安普蕾洗护套组（强韧洗发水269ml/补水护发素269ml），价值538元；</p>
            <p >·赠送HEAD SPA森林舒压服务项目1次，价值798元；</p>
            <p >·西班牙特斯嘉科技头皮2次，五折优惠；</p>
          </div>
        </div>
        <div  className="card clearfix">
          <div  className="cardName flexBox">
            <img  src="image/金卡.jpg" alt="" />金卡会员 5,000RMB </div>
          <div  className="cardInfo flexBox">
            <p >
              <strong >基础权益</strong>
            </p>
            <p >·店内部分项目享受8折优惠。</p>
            <p >·产品购买8折优惠</p><p >&nbsp;</p>
            <p >
              <strong >增值权益</strong>
            </p>
            <p >·赠送安普蕾强韧洗发水一瓶269ml，价值269元；</p>
            <p >·赠送HEAD SPA瀑布舒氧服务项目1次，价值598元；</p>
            <p >·西班牙特斯嘉科技头皮1次，五折优惠；</p>
          </div>
        </div>
        <div  className="card clearfix">
          <div  className="cardName flexBox">
            <img  src="image/普通会员.jpg" alt="" />
            普通会员 3,000RMB
          </div>
          <div  className="cardInfo flexBox">
            <p >
              <strong >基础权益</strong>
            </p>
            <p >·店内部分项目享受8.5折优惠。</p>
            <p >·产品购买8折优惠</p><p >&nbsp;</p>
            <p >
              <strong >增值权益</strong>
            </p>
            <p >·赠送安普蕾强韧洗发水一瓶120ml，价值79元；</p>
            <p >·赠送头皮舒缓服务项目 1次，价值 298 元；</p>
          </div>
        </div>
        <div  className="card clearfix">
          <div  className="cardName flexBox">
            <img  src="image/品鉴卡.jpg" alt="" />
            体验会员 1,980RMB
          </div>
          <div  className="cardInfo flexBox">
            <p >
              <strong >基础权益</strong>
            </p>
            <p >店内部分项目可以享受团购价优惠。</p>
            <p >赠送会员卡储值专项抵用券 500 元。</p>
            <p >产品购买8折优惠。</p>
            <p >注：新顾客首次到店【限购1次】。</p>
          </div>
        </div> 
        <div  className="cardNote">
          <p >*1.不与其他优惠同时享用</p>
          <p >2.赠送项目不可兑现，不可替换</p>
          <p >3.折扣以原价值计算</p>
          <p > 4.特殊项目价格请参看会员价格体系
            {/* <i  className="mIcon mu-icon  material-icons  " onClick={handleOpen}>info_outline</i> */}
          </p>
        </div>
        <div  className="luckdraw">
            <img  src="image/link.png" alt="" />
        </div>
        <div  className="blockTit" >会员规则</div>
        <div  className="blockText">
          <ol >
            <li >本会员卡仅限绑定一名持卡人，持卡人有权与他人共享使用。持卡人不在场的情况下，店铺需与持卡人取得联系，以便对用卡人进行身份确认，方可借让他人使用。如无法联系到持卡人，店铺有权拒绝本次持卡消费。</li>
            <li >本卡不设置有效期。</li>
            <li >店铺为预约制，所有项目（包括赠予项目）皆需预约后方可消费。如未经预约，店铺有权拒绝操作。</li>
            <li >会员需按预约时间准时到店，迟到15分钟以上，店铺有权拒绝操作。</li>
            <li >操作过程中全程禁止录像。</li>
          </ol>
        </div>
        <div  className="blockTit" >关于解约</div>
        <div  className="blockText">
          <ol >
            <li >因会员客观原因（长期出差、公派出国、入院手续、怀孕）需要解除合约，店铺同意其自行转卡，赠送项目和已消费项目，无需折算原价，剩余权益和余额，皆不做更改。如办理转卡，需双方到店，另行办理转卡手续。</li>
            <li >因会员客观原因（长期出差，公派出国，入院手续，怀孕）要求解除合约，将按各项目原价格进行已消费项目、产品的重新核算，原价格以店面正在执行的价格为准，只返还原价格抵扣后的余额部分。</li>
            <li >入会后的赠予部分，如产品赠予、项目赠予等，将按已赠予的各项目、产品的原价格进行核算，原价格以店面正在执行的价格为准，只返还原价格抵扣后的余额部分。</li>
            <li >确认解约，需缴纳原值核算后，剩余金额的20%作为违约金。</li>
            <li >解约流程，需要客户实际到店办理，签署退款确认函后，方可进入正式退款流程。如客户不方便到店，店面有权通过电话、语音等方式核实客户身份，以保证客户资金安全。</li>
            <li >解约退款仅限银行卡，微信，支付宝几种形式。</li>
            <li >退款流程为7-10个工作日。</li>
            <li >因店铺原因（店铺拆迁，暂停运营）要求解约，为店面责任，按会员折扣价与客户确认卡内余额后，在15个工作日内退还全部余额。赠予部分无需返还。</li>
          </ol>
        </div>
      </div>


      <Modal open={open} onClose={() => setOpen(false)}>
          <img  src="image/pageM.png" alt=""/>
      </Modal>
      <section  onClick={()=>scrollTop()} id="toTop"><span >PAGE TOP</span></section>
    </div>
  );
}